import React, { useMemo, Fragment } from "react";
import { useCompanyList } from "../../data/companies/useCompanyList";
import { Select, SelectProps } from "semantic-ui-react";
import { ICompany } from "../../models/ICompany";
import { useTranslation } from "react-i18next";
import { useBool } from "@sg-core/index"
import AddCompanyModal from "./AddCompanyModal";

const CREATE_COMPANY = "create";

const makeOption = (company: ICompany): SelectProps["options"][any] => ({
    text: company.name,
    value: company.id
});

interface CompanySelectProps extends Omit<SelectProps, "options"> { };

export const CompanySelect: React.FC<CompanySelectProps> = ({
    children,
    onChange,
    multiple,
    value,
    ...selectProps
}) => {
    const t = useTranslation().t;
    const texts = {
        selectCompany: t("Valitse yritys"),
        createCompany: t("Lisää yritys")
    };


    const { data: companies, fetching } = useCompanyList();

    const options = useMemo(() => [
        ...companies.map(makeOption),
        { text: texts.createCompany, value: CREATE_COMPANY, icon: "plus" }
    ], [companies]); // eslint-disable-line

    const [creatingModal, showAddCompany, hideAddCompany] = useBool();

    const _onChange: SelectProps["onChange"] = (_1, data) => {
        if (data.value === CREATE_COMPANY) {
            showAddCompany();
            return
        }
        onChange && onChange(data.value);
    };


    const handleNewCompany = (company: ICompany) => {
        onChange && onChange(company.id);
        hideAddCompany();
    };


    return (
        <Fragment>
            <Select
                clearable
                search
                loading={fetching}
                placeholder={texts.selectCompany}
                options={options}
                onChange={_onChange}
                {...selectProps}
                value={value}
            />
            {creatingModal && (
                <AddCompanyModal
                    open={creatingModal}
                    onSuccess={handleNewCompany}
                    onCancel={hideAddCompany}
                />
            )}
        </Fragment>
    );
};


